import EmploymentPosition from '../model/employmentPosition'
import { RequestResponse, secureRequest, url } from '../utils/request-utils'

export function fetchEmploymentPositions(): Promise<RequestResponse<EmploymentPosition[]>> {
  return secureRequest('GET', url('/v2/employmentPositions', { country: 'DK' }))
}
